import { render, staticRenderFns } from "./DailyStockReport.vue?vue&type=template&id=60ed359e&"
import script from "./DailyStockReport.vue?vue&type=script&lang=ts&"
export * from "./DailyStockReport.vue?vue&type=script&lang=ts&"
import style0 from "./DailyStockReport.vue?vue&type=style&index=0&id=60ed359e&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports